import { useDisclosure } from '@chakra-ui/react';

import {
  IOfferingRes,
  IProduct,
  IRateReqSchemaUI,
  PriceDisplayEnum,
} from '@monetize/types/app';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { MdSettings } from 'react-icons/md';
import { MButton } from '../../../../../components/Monetize';
import MPopoverWrapper from '../../../../../components/Monetize/MPopoverWrapper';
import { PriceDisplaySettingsTable } from '../../../../../components/Quotes/PriceDisplaySettingsTable';

interface RateSettingsPopoverProps {
  offering?: IOfferingRes;
  products: IProduct[];
  handleSave: () => void;
}

export const RateSettingsPopover: FC<RateSettingsPopoverProps> = ({
  offering,
  products,
  handleSave,
}: RateSettingsPopoverProps) => {
  const { getValues, setValue } = useFormContext<IRateReqSchemaUI>();
  const rate = getValues();

  const { onOpen, onClose, open } = useDisclosure();

  const onSave = async (value: PriceDisplayEnum) => {
    await setValue(
      'options',
      {
        priceDisplay: value,
        productOptions: rate.options?.productOptions || [],
        tokenAllocationFrequencyInMonth: null,
      },
      { shouldDirty: true, shouldValidate: true },
    );
    onClose();
    handleSave();
  };

  function handleOnOpen() {
    onOpen();
  }
  return (
    <MPopoverWrapper
      usePortal
      placement="bottom-start"
      isOpen={open}
      onOpen={handleOnOpen}
      onClose={onClose}
      triggerContent={
        <MButton variant="tertiary" minWidth="auto" leftIcon={<MdSettings />}>
          Settings
        </MButton>
      }
      popoverContentProps={{
        display: 'flex',
        alignItems: 'center',
        border: 'none',
        bg: 'transparent',
        zIndex: 200,
        minW: '510px',
      }}
      popoverBodyProps={{
        boxShadow: '0px 4px 25px 0px #B4BCEF61',
        bg: '#FFF',
      }}
      showArrow
      bodyContent={
        <>
          <PriceDisplaySettingsTable
            value={rate?.options?.priceDisplay}
            onChange={onSave}
            rate={rate}
            quoteOfferingName={offering?.name || ''}
            products={products}
            isLoading={false}
          />
        </>
      }
    />
  );
};
